import { create } from "zustand";

// Const assertion object for all possible paywall types
export const PAYWALL_TYPES = {
  // File upload related
  FILE_UPLOAD: "file_upload",
  FILE_UPLOAD_EXCEEDS_SIZE_LIMIT: "file_upload_exceeds_size_limit",
  FILE_UPLOAD_FAILURE_IN_QUIZ: "file_upload_failure_in_quiz",

  // AI tutor related
  AI_TUTOR: "ai_tutor",
  AI_EXPLANATION: "ai_explanation",

  // Navigation and UI components
  NAV_UPGRADE_BUTTON: "nav_upgrade_button",
  SIDEBAR_UPGRADE_BUTTON: "sidebar_upgrade_button",
  UPGRADE_CARD_STUDYSET_PAGE: "upgrade_card_studyset_page",
  UNLOCK_QUESTIONS_STUDYSET_PAGE: "upgrade_study_set_page_questions_blurred",

  // Quiz related
  UNLOCK_QUESTIONS_QUIZ_PAGE: "unlock_questions_quiz_page",

  // Content creation
  YOUTUBE_URL: "youtube_url",
  PASTE_TEXT: "paste_text",

  // Features
  AUTOCOMPLETION: "autocompletion",

  // Settings
  BILLING_PAGE: "billing page",

  // Fall Sale
  FALL_SALE: "fall_sale",

  // AI Notes related
  AI_NOTES_DURATION: "ai_notes_duration", // 30 minutes
  AI_NOTES_COUNT: "ai_notes_count", // 2 note

  // Audio Study related
  AUDIO_LESSON: "audio_lesson", // 2 free lessons
  VOICE_TUTOR: "voice_tutor", // 3 free voice questions

  // Practice Test related
  PRACTICE_TEST_LENGTH: "practice_test_length", // free tier capped at 10 questions
  PRACTICE_TEST_LIMIT: "practice_test_limit", // free tier capped at 3 lifetime tests
} as const;

// Union type for better type safety and developer experience
export type PaywallType = (typeof PAYWALL_TYPES)[keyof typeof PAYWALL_TYPES];

interface Args {
  upgradeReason?: string;
  studySetId?: string;
  description?: string;
  paywallType?: PaywallType;
}

interface ModalStore {
  isOpen: boolean;
  upgradeReason?: string;
  studySetId?: string;
  description?: string;
  paywallType?: PaywallType;
  onOpen: ({
    upgradeReason,
    studySetId,
    description,
    paywallType,
  }: Args) => void;
  onClose: () => void;
}

const usePricingModal = create<ModalStore>((set) => ({
  studySetId: undefined,
  upgradeReason: undefined,
  description: undefined,
  isOpen: false,
  onOpen: ({ upgradeReason, studySetId, description, paywallType }) =>
    set({ isOpen: true, upgradeReason, studySetId, description, paywallType }),
  onClose: () =>
    set({
      isOpen: false,
      upgradeReason: undefined,
      description: undefined,
      studySetId: undefined,
      paywallType: undefined,
    }),
}));

export default usePricingModal;
